import { Autocomplete, TextField } from "@mui/material";
import Component from "components/Component";
import DefaultLoader from "components/common/DefaultLoader";
import Disabled from "components/common/Disabled";
import * as labels from "config.labels";
import { connect } from "react-redux";
import * as actions from "store/actions/input/program/programActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";

export const IndustryClassComponent = (props) => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const industryClassLabel = translateLabel(labels.INDUSTRY_CLASS, {
    default: "Industry Class",
  });

  const industryClasses =
    props.industryClasses?.filter(
      ({ key, isDeactivated }) => props.industryClass === key || !isDeactivated
    ) ?? [];

  return (
    <Component
      title={industryClassLabel}
      subtitle={translateLabel(labels.INDUSTRY_CLASS_SUBTITLE, {
        default:
          "The industry class determines which Exposure input metrics are appropriate.",
      })}
      {...props.componentProps}
    >
      {props.loadingIndustryClasses ? (
        <DefaultLoader
          style={{
            width: "100%",
            height: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          size={60}
        />
      ) : (
        <Disabled ifReadOnly>
          <Autocomplete
            options={industryClasses}
            getOptionKey={({ key }) => key}
            getOptionLabel={({ name }) => name ?? ""}
            value={
              industryClasses.find((x) => x.key === props.industryClass) ?? null
            }
            onChange={(_, value) => {
              props.updateIndustryClass(value?.key ?? null);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant={"filled"}
                label={industryClassLabel}
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </Disabled>
      )}
    </Component>
  );
};

const mapDispatchToProps = {
  updateIndustryClass: actions.updateIndustryClass,
};

const mapStateToProps = (state) => {
  return {
    industryClass: state.input.program.industryClass,
    industryClasses: state.temp.exposureMetrics?.industryClassChoices || [],
    loadingIndustryClasses: state.temp.exposureMetrics?.loadingIndustryClasses,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IndustryClassComponent);
